import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";
import api from "@/services/api";

export default {
  async getStatistics(id) {
    try {
      const { data } = await api.get(url(ENDPOINTS.statistics, { id: id }));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getApartmentStatistics(coopId, apartId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.apartStatistics, {
          coopId,
          apartId,
        })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getCooperativeStatistics(coopId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.cooperativeStatistics, { coopId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getGroupStatistics(coopId, groupId) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.groupStatistics, { coopId, groupId })
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getCooperatives(coopId) {
    try {
      const { data } = await api.get(url(ENDPOINTS.cooperatives, { coopId }));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
